<template>
  <div id="page-user-view pt-20">
    <div class="">
      <template>
        <vs-navbar class="p-2">
          <div slot="title" class="nav-img-for-gu">
            <vs-navbar-title>
              <img src="@/assets/images/pages/logo.png" alt="">
            </vs-navbar-title>
          </div>

          <vs-navbar-item index="0">

          </vs-navbar-item>

          <vs-navbar-item index="1">

          </vs-navbar-item>

          <vs-navbar-item index="2">

          </vs-navbar-item>
        </vs-navbar>
      </template>
    </div>
    <div id="user-data">
      <vx-card title="Applicant and Purchase Information">


      <vx-card title="Personal Information" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">

          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <!--          <img :src="user_data.avatar" class="rounded w-full" />-->
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div v-if="userInfo.ekyc.parsonal !== null" class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Name</td>
                <td>{{ userInfo.ekyc.parsonal.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Father’s Name</td>
                <td>{{ userInfo.ekyc.parsonal.father_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Mother’s Name</td>
                <td>{{ userInfo.ekyc.parsonal.mother_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Spouse Name</td>
                <td>{{ userInfo.ekyc.parsonal.spouse_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Age</td>
                <td>{{ userInfo.ekyc.parsonal.age }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Marital Status</td>
                <td>{{ userInfo.ekyc.parsonal.marital_status }}</td>
              </tr>


            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div v-if="userInfo.ekyc.parsonal !== null" class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Gender</td>
                <td>{{ userInfo.ekyc.parsonal.gender }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Head of Household</td>
                <td>{{ userInfo.ekyc.parsonal.head_of_household }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Education Level</td>
                <td>{{ userInfo.ekyc.parsonal.education_level }}</td>
              </tr>
              <tr>
                <td class="font-semibold">NID No</td>
                <td>{{ userInfo.ekyc.parsonal.nid }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
        </div>

      </vx-card>
      <vx-card v-if="userInfo.ekyc.contact !== null" title="Contact Information">
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold">Mobile</td>
              <td> {{ userInfo.ekyc.phone }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Other Phone</td>
              <td> {{ userInfo.ekyc.contact.other_phone||'' }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Email</td>
              <td> {{ userInfo.ekyc.contact.email ||''}}</td>
            </tr>
          </table>
        </div>
        <br>
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full">
            <vx-card title="Present Address" class="mb-base">
              <table>
                <tr>
                  <td class="font-semibold">Division</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.division }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">District</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.district }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Thana</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.thana }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Apt#/House#/Road#/Village#</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.address }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Nearby Famous Landmark</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.near_landmark}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Postal code</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.postal_code}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Household Type</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.house_hold_type}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Living in this address</td>
                  <td>{{ userInfo.ekyc.contact.presentAddress.living_in_this_address}}</td>
                </tr>
              </table>
            </vx-card>
          </div>

          <div class="vx-col lg:w-1/2 w-full">
            <vx-card title="Permanent Address" class="mb-base">
              <table>
                <tr>
                  <td class="font-semibold">Division</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.pdivision }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">District</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.pdistrict }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Thana</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.pthana }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Apt#/House#/Road#/Village#</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.paddress }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Nearby Famous Landmark</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.pnear_landmark}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Postal code</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.ppostal_code}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Household Type</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.phouse_hold_type}}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Living in this address</td>
                  <td>{{ userInfo.ekyc.contact.permanentAddress.pliving_in_this_address}}</td>
                </tr>
              </table>
            </vx-card>
          </div>
        </div>
      </vx-card>
      <br>
      <!--      Occupation and dependant-->
      <div class="vx-row">
        <div v-if="userInfo.ekyc.occupation !== null"  class="vx-col lg:w-1/2 w-full">
          <vx-card title="Occupation Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Occupation Type</td>
                <td>{{ userInfo.ekyc.occupation.occupation_type }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Organization Type</td>
                <td>{{ userInfo.ekyc.occupation.occupation }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Monthly Income In BDT</td>
                <td>{{ userInfo.ekyc.occupation.monthly_income }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Name of the Office/Business</td>
                <td>{{ userInfo.ekyc.occupation.name_of_Office_or_business }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Designation</td>
                <td>{{ userInfo.ekyc.occupation.designation}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Job length</td>
                <td>{{ userInfo.ekyc.occupation.job_length}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Division</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.division}}</td>
              </tr>
              <tr>
                <td class="font-semibold">District</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.district}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Thana</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.thana}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Office Area</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.office_area}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Apt#/House#/Road#/Village#</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.address}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Postal code</td>
                <td>{{ userInfo.ekyc.occupation.occupationAddress.postal_code}}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card v-if="userInfo.ekyc.dependent !== null" title="Dependent Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">No. of Children living with you</td>
                <td>{{ userInfo.ekyc.dependent.number_of_child }}</td>
              </tr>
              <tr>
                <td class="font-semibold">No. of dependent living with you</td>
                <td>{{ userInfo.ekyc.dependent.number_of_dependent }}</td>
              </tr>
              <br>
              <!--<tr>
                <td class="font-semibold">Relation</td>
                <td class="font-semibold">Name</td>
                <td class="font-semibold">Age</td>
              </tr>
              <tr v-for="(dependent, index) in userInfo.ekyc.dependent.depandantDetails" :key="index">
                <td>{{ dependent.relation }}</td>
                <td>{{ dependent.name }}</td>
                <td>{{ dependent.age }}</td>
              </tr>-->
            </table>
            <vs-table stripe  v-if="dependentDetailsArr !== null" style="max-height: 235px; overflow: scroll; width: 100%">
              <template slot="thead">
                <vs-th>Relation</vs-th>
                <vs-th>Name</vs-th>
                <vs-th>Age</vs-th>
              </template>
              <template>
                <vs-tr  v-for="(dependent, indextr) in dependentDetailsArr" :key="indextr">
                  <vs-td>
                    {{dependent.relation}}
                  </vs-td>
                  <vs-td>
                    {{dependent.name}}
                  </vs-td>
                  <vs-td>
                    {{dependent.age}}
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
      <!-- Showroom and Product  -->
      <div class="vx-row">
        <div v-if="purchaseInfo !== null"  class="vx-col lg:w-1/2 w-full">
          <vx-card title="Showroom Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Address</td>
                <td>{{ purchaseInfo.showroom.address }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Manager Name</td>
                <td>{{ purchaseInfo.showroom.manager_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Phone</td>
                <td>{{ purchaseInfo.showroom.phone }}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card v-if="purchaseInfo !== null" title="Product Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Product Name</td>
                <td>{{ purchaseInfo.product.product }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Brand</td>
                <td>{{ purchaseInfo.brand }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Price Range</td>
                <td>{{ purchaseInfo.brand }}</td>
              </tr>

            </table>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button  color="success" class="mr-3 mb-2 float-right"  @click="acceptGuarantor(2)">Accept</vs-button>
          <vs-button  color="warning" class="mr-3 mb-2 float-right"  @click="acceptGuarantor(3)">Reject</vs-button>
        </div>
      </div>
      <br>
      </vx-card>
    </div>
  </div>
</template>
<script>
  import acceptReject from '../graphql/GuarantorAcceptAndReject.gql'
  import {ME} from '../graphql/userinfo'
  import gql from 'graphql-tag'


  export default {
    data () {
      return {
        userInfo: {
          ekyc:{
            parsonal :{},
            contact :{},
            occupation :{},
            dependent :{},
            purchaseInfo :{}
          }
        },
        dependentDetailsArr: [],
        guarantorId :'',
        ekycId : '',

      }
    },
    apollo: {
      guarantor: {
        query: gql`
          query guarantor($token: String!){
            guarantor(token: $token){
                    id
                    name
                    email
                    status
                    purchase{
                      id
                      product{
                        id
                        product
                      }
                      price_range
                      brand
                      showroom{
                        id
                        address
                        phone
                        manager_name
                      }
                      user{
                        id
                        name
                        phone
                        ekyc{
                          phone
                          status
                           parsonal{
                            id
                            name
                            father_name
                            mother_name
                            spouse_name
                            age
                            marital_status
                            gender
                            head_of_household
                            education_level
                            nid
                          }
                          contact{
                            id
                            mobile
                            other_phone
                            email
                            presentAddress{
                              id
                              division
                              district
                              thana
                              address
                              near_landmark
                              postal_code
                              house_hold_type
                              living_in_this_address
                            }
                            permanentAddress{
                              id
                              pdivision
                              pdistrict
                              pthana
                              paddress
                              pnear_landmark
                              ppostal_code
                              phouse_hold_type
                              pliving_in_this_address
                            }
                          }
                          occupation{
                            id
                            occupation_type
                            occupation
                            monthly_income
                            name_of_Office_or_business
                            designation
                            job_length
                            occupationAddress{
                              id
                              division
                              district
                              thana
                              office_area
                              address
                              postal_code
                            }
                          },
                          dependent{
                            id
                            number_of_child
                            number_of_dependent
                            depandantDetails{
                              id
                              relation
                              name
                              age
                            }
                          }
                        }
                      }
                    }
                    ekyc{
                      id
                      phone
                      status
                    }

            }
          }
        `,
        variables () {
          // Use vue reactive properties here
          return {
            token: this.$route.params.token
          }
        },
        update: (data) => data.guarantor
      }
    },
    watch:{
      guarantor(value){
        console.log("Me computedf value: ", value);
        if(value.status === 4){
          this.$router.push('/greetings-submission').catch(() => {})
          console.log("G Status ",value.status);
        }else if(value.status === 3){
          this.$router.push('/reject-submission').catch(() => {})
          console.log("G Status ",value.status);
        }
        this.purchaseInfo = value.purchase;
        console.log("purchaseInfo = :", this.purchaseInfo);
        this.userInfo = value.purchase.user;
        console.log("Me Applicant EKYC: ", this.userInfo);
        this.dependentDetailsArr = this.userInfo.ekyc.dependent.depandantDetails;
        this.guarantorId = value.id;
        this.ekycId = value.ekyc.id;
      }
    },
    methods: {
      async acceptGuarantor (status) {
        await this.$apollo.mutate({
          mutation: acceptReject,
          variables: {
            id: this.guarantorId,
            status: status,
          }
        }).then((data) => {
          console.log('Data = ', data);
          console.log('Data2 = ', data.data.acceptOrRejectByGuarantor);
          this.guarantorId = data.data.acceptOrRejectByGuarantor.id;
          this.ekycId = data.data.acceptOrRejectByGuarantor.ekyc.id;
          this.$router.push('/guarantorInfos/'+this.guarantorId+'/'+this.ekycId).catch(() => {})
          this.$apollo.queries.user.refetch();
          this.$vs.notify({
            title: 'Accept Or Reject',
            text: 'Accept',
            color: "success",
            position: 'top-right'
          })
        }).catch((error) => {
        })

      },
      // async acceptGuarantor () {
      //
      //   this.$router.push('/guarantorInfos/'+this.guarantorId+'/'+this.ekycId).catch(() => {
      //   })
      // },
    }
  }
</script>

<style>
  .vx-col table tr > td {
    vertical-align: top;
    min-width: 250px;
    word-break: break-all;
  }

  #page-user-view table td {
    vertical-align: top;
    min-width: 250px;
    word-break: break-all;
  }
  .nav-img-for-gu img {
    height: 55px;
    padding: 5px 0;
  }
  #user-data {
    padding: 15px 30px;
  }
</style>
